import { useDevicesContext } from "@hireroo/app-helper/hooks";
import { RemoteUser } from "@hireroo/app-helper/livecoding/agora";
import { Auth } from "@hireroo/app-store/essential/candidate";
import { RemotesId } from "@hireroo/app-store/page/c/remotes_id";
import { Widget } from "@hireroo/presentation";
import React from "react";

import LiveCodingDeviceSettingsContainer from "../../../../../../widget/v2/shared/LiveCodingDeviceSettings/Container";
import LiveCodingVideoViewContainer from "../../../../../../widget/v2/shared/LiveCodingVideoView/Container";
import LiveCodingVideoChatGalleryLayoutContainer from "../LiveCodingVideoChatGalleryLayout/Container";

export type GenerateLiveCodingVideoChatPopperPropsArgs = {};

export const useGenerateProps = (_args: GenerateLiveCodingVideoChatPopperPropsArgs): Widget.LiveCodingVideoChatPopperProps => {
  const uid = Auth.useCurrentUid();
  const user = RemotesId.useCandidateUser(uid ?? "");

  const { isVideoEnabled, isAudioEnabled, toggleVideo, toggleAudio } = useDevicesContext();

  const localUser = React.useMemo((): RemoteUser => {
    return {
      uid: user.userId,
      hasAudio: isAudioEnabled,
      hasVideo: isVideoEnabled,
    };
  }, [user.userId, isAudioEnabled, isVideoEnabled]);

  return {
    Layout: <LiveCodingVideoChatGalleryLayoutContainer />,
    menuBar: {
      audioToggleButton: {
        isEnabled: isAudioEnabled,
        onClick: () => {
          toggleAudio();
        },
      },
      videoToggleButton: {
        isEnabled: isVideoEnabled,
        onClick: () => {
          toggleVideo();
        },
      },
    },
    videoChatDraggablePrompt: {},
    settingDialog: {
      VideoContent: <LiveCodingVideoViewContainer user={localUser} isLocal={true} />,
      deviceToggleButtons: {
        audioToggleButton: {
          isEnabled: isAudioEnabled,
          onClick: () => {
            toggleAudio();
          },
        },
        videoToggleButton: {
          isEnabled: isVideoEnabled,
          onClick: () => {
            toggleVideo();
          },
        },
      },
      permissionState: "granted",
      DeviceSettings: <LiveCodingDeviceSettingsContainer />,
    },
  };
};
